import { Button, Col, Heading, HorizontalRule, StatusLabel } from '@snsw/react-component-library';
import { GelTheme } from 'components/GelTheme';
import { FlexBox } from 'components/Layout';
import { Fragment } from 'react';
import styled from 'styled-components';
import { ListViewItem, ListViewRowDetailsProps } from '../types';

export const PipeContainer = styled.div`
  padding-left: 9px;
  padding-right: 9px;
  padding-top: 4px;
`;

export const PipeLine = styled.div`
  border-left: 1.5px solid ${GelTheme.color('shuttle')};
  height: ${GelTheme.spacing(1)};
`;

export const TypeHeading = styled(Heading)`
  margin: 0;
`;

export const ListViewDetailsLabel = styled.div`
  font-weight: ${GelTheme.fontWeight('normal')};
  font-size: 1rem;
  line-height: 24px;
  margin-top: ${GelTheme.spacing(0.5)};
`;

export const ListViewDetailsValue = styled.span`
  font-weight: ${GelTheme.fontWeight('normal')};
  font-size: 1rem;
  line-height: 24px;
  margin-top: ${GelTheme.spacing(0.5)};
`;

export const DetailStatus = styled.div`
  height: 30px;
  & > span {
    font-weight: ${GelTheme.fontWeight('semi-bold')};
  }
`;

export const HeadingContainer = styled.div`
  margin-top: 1rem;
`;

export const HeadingText = styled(Heading)`
  font-size: 1.75rem;
  margin-bottom: ${GelTheme.spacing(0.5)};
`;

export const HelpMessage = styled.div`
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${GelTheme.color('shuttle')};
  margin: 0;
`;

export const HorizontalRuleStyled = styled(HorizontalRule)`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const EditRemoveContainer = styled(Col)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;

  @media (max-width: 480px) {
    margin-top: 0.75rem;
    justify-content: flex-start;
  }

  button {
    min-width: 0;
    width: auto;
  }
`;

export const Pipe = () => (
  <PipeContainer>
    <PipeLine />
  </PipeContainer>
);

export const defaultRenderRowTitle = (_index: number, item: ListViewItem) => (
  <>
    {item?.isCompleted === false ? ( // By using the strict check I make sure I display the label only when needed
      <DetailStatus>
        <StatusLabel text="Incomplete" variant="warning" />
      </DetailStatus>
    ) : null}
    <TypeHeading level={4}>{item?.typeText}</TypeHeading>
  </>
);

export const headingOnlyRenderTitle = (_index: number, item: ListViewItem) => (
  <TypeHeading level={4}>{item?.typeText}</TypeHeading>
);

export const defaultRenderRowDetails = (index: number, item: ListViewItem) =>
  item?.details?.map((detail) => (
    <ListViewDetailsLabel key={`${index}-${detail.label}`}>
      {`${detail.label}: `}
      <ListViewDetailsValue>{detail.value}</ListViewDetailsValue>
    </ListViewDetailsLabel>
  ));

export const qualificationRowDetails = (index: number, item: ListViewItem) =>
  item?.details?.map((detail) => (
    <Fragment key={`${index}-${detail.label}`}>
      <ListViewDetailsLabel>{`${detail.label}`}</ListViewDetailsLabel>
      <ListViewDetailsValue>{detail.value}</ListViewDetailsValue>
    </Fragment>
  ));

export const employeeRenderRowDetails = (index: number, item: ListViewItem) =>
  item?.details?.map((detail) => (
    <ListViewDetailsLabel key={`${index}-${detail.value}`}>{`${detail.value}`}</ListViewDetailsLabel>
  ));

export const ListViewRowDetails = ({
  items,
  renderRowTitle,
  renderRowDetails,
  showEditRemove,
  onClickEditRow,
  onClickRemoveRow,
}: ListViewRowDetailsProps) => {
  return (
    <>
      {items.map((item, index) => (
        <Fragment key={index}>
          <ItemContainer>
            <FlexBox direction="column" alignItems="flex-start">
              {renderRowTitle(index, item)}
              {renderRowDetails(index, item)}
            </FlexBox>
            {showEditRemove && (
              <EditRemoveContainer span={3}>
                <Button
                  variant="link"
                  onClick={() => {
                    onClickEditRow(index);
                  }}
                >
                  Edit
                </Button>
                <Pipe />
                <Button
                  variant="link"
                  onClick={() => {
                    onClickRemoveRow(index);
                  }}
                >
                  Remove
                </Button>
              </EditRemoveContainer>
            )}
          </ItemContainer>
          <HorizontalRuleStyled />
        </Fragment>
      ))}
    </>
  );
};
